import CustomModal from "@UI/CustomModal"
import PropTypes from "prop-types"
import { ReactComponent as CloseIcon } from '@assets/icons/Generals/close-red-x-icon.svg'
import { Button } from "antd"
import './styles.css'
import { useExonerateModal } from "./hooks/useExonerateModal"

const ExonerateModal = ({
  isOpen,
  onClose,
  record
}) => {

  const { handleExonerate, isLoadingExonerateModal } = useExonerateModal({ onClose })
  return (
    <CustomModal
      className="custom-modal"
      isOpenModal={isOpen}
      onCancel={() => onClose({ isOpen: false, name: 'exonerate' })}
      width={500}
    >
      <div className="exonerate-modal-title">
        <CloseIcon width={64} height={64} />
        <span>Exonerar</span>
        <p>El usuario quedara excluido de este cobro y no tendrá que pagar nada.</p>
      </div>
      <div className="exonerate-modal-buttons">
        <Button
          loading={isLoadingExonerateModal}
          className="btn-standard-white"
          onClick={() => onClose({ isOpen: false, name: 'exonerate' })}
          style={{
            width: '133px',
            borderRadius: '32px',
          }}
        >
          DESCARTAR
        </Button>
        <Button
          loading={isLoadingExonerateModal}
          className="btn-standard-green"
          onClick={() => handleExonerate({ record })}
          style={{
            width: '133px',
            borderRadius: '32px',
          }}
        >
          GUARDAR
        </Button>
      </div>
    </CustomModal>
  )
}

ExonerateModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  record: PropTypes.object
}


export default ExonerateModal
